import Button from '@/Components/Button';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import { Head, useForm } from '@inertiajs/inertia-react';
import date from '@/helpers/date';
import Authenticated from '@/Layouts/Authenticated';

const Create = (props) => {
    const { data, setData, processing, post } = useForm({
        'name': '',
        'code': '',
        'percent': 1,
        'limit': 1,
        'expiration': date.toString(date.addMonths(1, date.setHours(new Date()))),
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        post(route('coupons.store', {office: props.office}));
    }

    console.log(date.toString(date.addMonths(1, date.setHours(new Date()))));

    return (
        <Authenticated
            store={props.store}
            branchOffice={props.office}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Crear cupón de descuento</h2>}
        >
            <Head title="Crear cupón - Cerogrado" />
            <form onSubmit={submit} className="p-4 mt-8 max-w-3xl mx-auto">
                <div className="grid grid-cols-1 w-full gap-4 mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <Label forInput="name" value="Nombre del cupón" />
                            <Input
                                name="name"
                                handleChange={onHandleChange}
                                value={data.name}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="code" value="Codigo del cupón" />
                            <Input
                                name="code"
                                handleChange={onHandleChange}
                                value={data.code}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-span-3 md:col-span-2">
                            <Label forInput="percent" value="Porcentaje de descuento" />
                            <Input
                                name="percent"
                                handleChange={onHandleChange}
                                value={data.percent}
                                type="number"
                                min={1}
                                max={100}
                                className="w-full"
                            />
                        </div>
                        <div className="col-span-3 md:col-span-2">
                            <Label forInput="limit" value="Limite de usos del cupón" />
                            <Input
                                name="limit"
                                handleChange={onHandleChange}
                                value={data.limit}
                                type="number"
                                min={1}
                                className="w-full"
                            />
                        </div>
                        <div className="col-span-6 md:col-span-2">
                            <Label forInput="expiration" value="Fecha de expiración" />
                            <Input
                                name="expiration"
                                handleChange={onHandleChange}
                                value={data.expiration}
                                type="date"
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
                <Button processing={processing}>Guardar</Button>
            </form>
        </Authenticated>
    )
}

export default Create;